/**
 * @generated SignedSource<<344043879adb38a09b7e9524483424a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ChatPanelReportTaxonomyQuery$variables = {
  reportType?: string | null;
};
export type ChatPanelReportTaxonomyQuery$data = {
  readonly viewer: {
    readonly reportTaxonomy: string | null;
  } | null;
};
export type ChatPanelReportTaxonomyQuery = {
  variables: ChatPanelReportTaxonomyQuery$variables;
  response: ChatPanelReportTaxonomyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportType"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "reportType",
      "variableName": "reportType"
    }
  ],
  "kind": "ScalarField",
  "name": "reportTaxonomy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatPanelReportTaxonomyQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatPanelReportTaxonomyQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f6d73ba987e459fdc06f1fc91bed6181",
    "id": null,
    "metadata": {},
    "name": "ChatPanelReportTaxonomyQuery",
    "operationKind": "query",
    "text": "query ChatPanelReportTaxonomyQuery(\n  $reportType: String\n) {\n  viewer {\n    reportTaxonomy(reportType: $reportType)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f22dd70c52c9c10176b99ff58ac869d2";

export default node;
